var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vgt-wrap",
      class: {
        rtl: _vm.rtl,
        nocturnal: _vm.theme === "nocturnal",
        "black-rhino": _vm.theme === "black-rhino",
      },
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "vgt-loading vgt-center-align" },
            [
              _vm._t("loadingContent", [
                _c("span", { staticClass: "vgt-loading__content" }, [
                  _vm._v("\n\t\t\t\tLoading...\n\t\t\t"),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "vgt-inner-wrap",
          class: { "is-loading": _vm.isLoading },
        },
        [
          _vm.paginate && _vm.paginateOnTop
            ? _vm._t(
                "pagination-top",
                [
                  _c("vgt-pagination", {
                    ref: "paginationTop",
                    attrs: {
                      perPage: _vm.perPage,
                      rtl: _vm.rtl,
                      total: _vm.totalRows || _vm.totalRowCount,
                      mode: _vm.paginationMode,
                      nextText: _vm.nextText,
                      prevText: _vm.prevText,
                      rowsPerPageText: _vm.rowsPerPageText,
                      customRowsPerPageDropdown: _vm.customRowsPerPageDropdown,
                      paginateDropdownAllowAll: _vm.paginateDropdownAllowAll,
                      ofText: _vm.ofText,
                      pageText: _vm.pageText,
                      allText: _vm.allText,
                    },
                    on: {
                      "page-changed": _vm.pageChanged,
                      "per-page-changed": _vm.perPageChanged,
                    },
                  }),
                ],
                {
                  pageChanged: _vm.pageChanged,
                  perPageChanged: _vm.perPageChanged,
                  total: _vm.totalRows || _vm.totalRowCount,
                }
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "vgt-global-search",
            {
              attrs: {
                "search-enabled":
                  _vm.searchEnabled && _vm.externalSearchQuery == null,
                "global-search-placeholder": _vm.searchPlaceholder,
              },
              on: {
                "on-keyup": _vm.searchTableOnKeyUp,
                "on-enter": _vm.searchTableOnEnter,
              },
              model: {
                value: _vm.globalSearchTerm,
                callback: function ($$v) {
                  _vm.globalSearchTerm = $$v
                },
                expression: "globalSearchTerm",
              },
            },
            [
              _c(
                "template",
                { slot: "internal-table-actions" },
                [_vm._t("table-actions")],
                2
              ),
            ],
            2
          ),
          _vm._v(" "),
          _vm.selectedRowCount
            ? _c(
                "div",
                {
                  staticClass: "vgt-selection-info-row clearfix",
                  class: _vm.selectionInfoClass,
                },
                [
                  _vm._v("\n\t\t\t" + _vm._s(_vm.selectionInfo) + "\n\t\t\t"),
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.unselectAllInternal(true)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.clearSelectionText) +
                          "\n\t\t\t"
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "vgt-selection-info-row__actions vgt-pull-right",
                    },
                    [_vm._t("selected-row-actions")],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "vgt-fixed-header" }, [
            _vm.fixedHeader
              ? _c(
                  "table",
                  { class: _vm.tableStyleClasses },
                  [
                    _c("vgt-table-header", {
                      ref: "table-header-secondary",
                      tag: "thead",
                      attrs: {
                        columns: _vm.columns,
                        "line-numbers": _vm.lineNumbers,
                        selectable: _vm.selectable,
                        "all-selected": _vm.allSelected,
                        "all-selected-indeterminate":
                          _vm.allSelectedIndeterminate,
                        mode: _vm.mode,
                        sortable: _vm.sortable,
                        "typed-columns": _vm.typedColumns,
                        getClasses: _vm.getClasses,
                        searchEnabled: _vm.searchEnabled,
                        paginated: _vm.paginated,
                        "table-ref": _vm.$refs.table,
                      },
                      on: {
                        "on-toggle-select-all": _vm.toggleSelectAll,
                        "on-sort-change": _vm.changeSort,
                        "filter-changed": _vm.filterRows,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-column",
                            fn: function (props) {
                              return [
                                _vm._t(
                                  "table-column",
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(props.column.label)),
                                    ]),
                                  ],
                                  { column: props.column }
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { "vgt-responsive": _vm.responsive },
              style: _vm.wrapperStyles,
            },
            [
              _c(
                "table",
                { ref: "table", class: _vm.tableStyleClasses },
                [
                  _c("vgt-table-header", {
                    ref: "table-header-primary",
                    tag: "thead",
                    attrs: {
                      columns: _vm.columns,
                      "line-numbers": _vm.lineNumbers,
                      selectable: _vm.selectable,
                      "all-selected": _vm.allSelected,
                      "all-selected-indeterminate":
                        _vm.allSelectedIndeterminate,
                      mode: _vm.mode,
                      sortable: _vm.sortable,
                      "typed-columns": _vm.typedColumns,
                      getClasses: _vm.getClasses,
                      searchEnabled: _vm.searchEnabled,
                    },
                    on: {
                      "on-toggle-select-all": _vm.toggleSelectAll,
                      "on-sort-change": _vm.changeSort,
                      "filter-changed": _vm.filterRows,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "table-column",
                          fn: function (props) {
                            return [
                              _vm._t(
                                "table-column",
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(props.column.label)),
                                  ]),
                                ],
                                { column: props.column }
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.paginated, function (headerRow, index) {
                    return _c(
                      "tbody",
                      { key: index },
                      [
                        _vm.groupHeaderOnTop
                          ? _c("vgt-header-row", {
                              attrs: {
                                "header-row": headerRow,
                                columns: _vm.columns,
                                "line-numbers": _vm.lineNumbers,
                                selectable: _vm.selectable,
                                "collect-formatted": _vm.collectFormatted,
                                "formatted-row": _vm.formattedRow,
                                "get-classes": _vm.getClasses,
                                "full-colspan": _vm.fullColspan,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "table-header-row",
                                    fn: function (props) {
                                      return _vm.hasHeaderRowTemplate
                                        ? [
                                            _vm._t("table-header-row", null, {
                                              column: props.column,
                                              formattedRow: props.formattedRow,
                                              row: props.row,
                                            }),
                                          ]
                                        : undefined
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(headerRow.children, function (row, index) {
                          return [
                            _c(
                              "tr",
                              {
                                key: row.originalIndex,
                                ref: "rows",
                                refInFor: true,
                                class: [_vm.getRowStyleClass(row)],
                                on: {
                                  mouseenter: function ($event) {
                                    return _vm.onMouseenter(row, index)
                                  },
                                  mouseleave: function ($event) {
                                    return _vm.onMouseleave(row, index)
                                  },
                                  dblclick: function ($event) {
                                    return _vm.onRowDoubleClicked(
                                      row,
                                      index,
                                      $event
                                    )
                                  },
                                  click: function ($event) {
                                    return _vm.onRowClicked(row, index, $event)
                                  },
                                  auxclick: function ($event) {
                                    return _vm.onRowAuxClicked(
                                      row,
                                      index,
                                      $event
                                    )
                                  },
                                },
                              },
                              [
                                _vm.lineNumbers
                                  ? _c("th", { staticClass: "line-numbers" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.getCurrentIndex(index)) +
                                          "\n\t\t\t\t\t\t\t"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.selectable
                                  ? _c(
                                      "th",
                                      { staticClass: "vgt-checkbox-col" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "vgt-checkbox-label kt-checkbox kt-checkbox--single",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _c("input", {
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: row.vgtSelected,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.onCheckboxClicked(
                                                    row,
                                                    index,
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span"),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.columns, function (column, i) {
                                  return !column.hidden && column.field
                                    ? _c(
                                        "td",
                                        {
                                          key: i,
                                          class: _vm.getClasses(i, "td", row),
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCellClicked(
                                                row,
                                                column,
                                                index,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._t(
                                            "table-row",
                                            [
                                              !column.html
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.collectFormatted(
                                                            row,
                                                            column
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              column.html
                                                ? _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.collect(
                                                          row,
                                                          column.field
                                                        )
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            {
                                              row: row,
                                              column: column,
                                              formattedRow:
                                                _vm.formattedRow(row),
                                              index: index,
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.isExpanded(row)
                              ? _c(
                                  "tr",
                                  {
                                    key: row.originalIndex + "-expanded",
                                    staticClass: "vgt-row-expanded",
                                  },
                                  [
                                    _c(
                                      "td",
                                      { attrs: { colspan: _vm.fullColspan } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "vgt-row-expanded__inner",
                                          },
                                          [
                                            _vm._t("expanded-row", null, {
                                              row: row,
                                              formattedRow:
                                                _vm.formattedRow(row),
                                              index: index,
                                            }),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                        _vm._v(" "),
                        _vm.groupHeaderOnBottom
                          ? _c("vgt-header-row", {
                              attrs: {
                                "header-row": headerRow,
                                columns: _vm.columns,
                                "line-numbers": _vm.lineNumbers,
                                selectable: _vm.selectable,
                                "collect-formatted": _vm.collectFormatted,
                                "formatted-row": _vm.formattedRow,
                                "get-classes": _vm.getClasses,
                                "full-colspan": _vm.fullColspan,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "table-header-row",
                                    fn: function (props) {
                                      return _vm.hasHeaderRowTemplate
                                        ? [
                                            _vm._t("table-header-row", null, {
                                              column: props.column,
                                              formattedRow: props.formattedRow,
                                              row: props.row,
                                            }),
                                          ]
                                        : undefined
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  _vm.showEmptySlot
                    ? _c("tbody", [
                        _c("tr", [
                          _c(
                            "td",
                            { attrs: { colspan: _vm.fullColspan } },
                            [
                              _vm._t("emptystate", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vgt-center-align vgt-text-disabled",
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.messages.NO_DATA_FOR_TABLE) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            2
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _vm.hasFooterSlot
            ? _c(
                "div",
                { staticClass: "vgt-wrap__actions-footer" },
                [_vm._t("table-actions-bottom")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.paginate && _vm.paginateOnBottom
            ? _vm._t(
                "pagination-bottom",
                [
                  _c("vgt-pagination", {
                    ref: "paginationBottom",
                    attrs: {
                      perPage: _vm.perPage,
                      rtl: _vm.rtl,
                      total: _vm.totalRows || _vm.totalRowCount,
                      mode: _vm.paginationMode,
                      nextText: _vm.nextText,
                      prevText: _vm.prevText,
                      rowsPerPageText: _vm.rowsPerPageText,
                      customRowsPerPageDropdown: _vm.customRowsPerPageDropdown,
                      paginateDropdownAllowAll: _vm.paginateDropdownAllowAll,
                      ofText: _vm.ofText,
                      pageText: _vm.pageText,
                      allText: _vm.allText,
                      hideRowCount: _vm.hideRowCount,
                    },
                    on: {
                      "page-changed": _vm.pageChanged,
                      "per-page-changed": _vm.perPageChanged,
                    },
                  }),
                ],
                {
                  pageChanged: _vm.pageChanged,
                  perPageChanged: _vm.perPageChanged,
                  total: _vm.totalRows || _vm.totalRowCount,
                }
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }